import { Skeleton, SkeletonBudgetRow } from '../UI/Skeleton';

/**
 * BudgetSkeleton - Loading skeleton for the budget dashboard
 */
export default function BudgetSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div>
        <Skeleton width="180px" height="1.75rem" className="mb-2" />
        <Skeleton width="280px" height="1rem" />
      </div>

      {/* Summary cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {['Total Budget', 'Total Spent', 'Remaining'].map((label, i) => (
          <div 
            key={label}
            className="p-4 rounded-lg"
            style={{ 
              backgroundColor: 'var(--color-bg-canvas)',
              border: '1px solid var(--color-border-subtle)',
            }}
          >
            <Skeleton width="90px" height="0.875rem" className="mb-2" />
            <Skeleton width="120px" height="1.75rem" className="mb-1" />
            <Skeleton width="60px" height="0.75rem" />
          </div>
        ))}
      </div>

      {/* Overall progress bar skeleton */}
      <div 
        className="p-4 rounded-lg"
        style={{ 
          backgroundColor: 'var(--color-bg-canvas)',
          border: '1px solid var(--color-border-subtle)',
        }}
      >
        <div className="flex justify-between items-center mb-3">
          <Skeleton width="140px" height="1rem" />
          <Skeleton width="60px" height="0.875rem" />
        </div>
        <Skeleton height="12px" rounded="full" className="mb-2" />
        <div className="flex gap-4">
          <div className="flex items-center gap-2">
            <Skeleton width="8px" height="8px" rounded="full" />
            <Skeleton width="50px" height="0.75rem" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton width="8px" height="8px" rounded="full" />
            <Skeleton width="50px" height="0.75rem" />
          </div>
        </div>
      </div>

      {/* Category breakdown section */}
      <div>
        <Skeleton width="180px" height="1.25rem" className="mb-4" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBudgetRow key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
